<section>
  <div class="header">
    <h1>{{ 'INCORRECT_PAYMENT.LIST_HEADER' | translate }}</h1>
  </div>

  <app-filter [filters]="filterDefinition" (change)="onFilterChange($event)" [defaultFilters]="defaultFilters"></app-filter>

  <app-paged-list-view
    [columnDefinition]="columnDefinitions"
    [contextMenuDefinition]="contextMenuDefinition"
    [menuDefinition]="menuDefinition"
    [itemsSource]="itemsSource"
    [totalCount]="totalResults"
    [pageNumber]="pageNumber"
    [itemsPerPage]="pageSize"
    [preferencesKey]="preferencesKey"
    (onPageChange)="pagingChanged($event)"
    (onSortChange)="sortChanged($event)"
    (rowClick)="onRowClicked($event)"
    [isToolbarSticky]="true"
  >
  </app-paged-list-view>
</section>
